export const getIdConvertedTimestamp = (id: string) => {
  const timestamp = id.substring(0, 8);

  return new Date(parseInt(timestamp, 16) * 1000);
};
